<template>
  <v-row no-gutters class="pt-5">
    <v-col style="border: 1px solid rgba(0, 0, 0, 0.12)">
      <v-data-table
        :headers="headers"
        :footer-props="{
          itemsPerPageOptions: [20, 50, 100],
        }"
        :items-per-page="20"
        :items="searchedItems"
        sort-by="id"
        :sort-desc="true"
      >
        <template #item.actions="{ item }">
          <dots-menu
            :items="dotsItems"
            @edit="$emit('toggleDialog', { type: 'input', item })"
            @delete="$emit('toggleDialog', { item })"
          />
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import { debounce, get as lodashGet } from 'lodash';

import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'FormPrintList',
  props: {
    searchValue: {
      type: String,
      default: '',
    },
  },
  components: {
    DotsMenu,
  },
  data: () => ({
    dotsItems: [{ name: 'edit' }, { name: 'delete' }],
    searchedItems: [],
  }),
  computed: {
    dataSources: get('layers/metadata'),
    layers: get('layers/layers'),
    smartMatch: get('smartMatch/profiles'),
    formPrints: get('formPrint/formPrints'),
    formPrintTemplates: get('formPrint/formPrintTemplates'),
    headers() {
      const inputs = ['id', 'name', 'form', 'smart_match', 'layer', 'relation_attribute'].map(header => {
        return {
          value: header,
          text: this.$i18n.t(`admin.formPrint.${header}`),
          align: 'center',
          searchable: ['name', 'form', 'smart_match', 'layer'].includes(header),
        };
      });
      return [...inputs, { value: 'actions', sortable: false }];
    },
    searchableHeadersValues() {
      return this.headers.filter(header => header.searchable).map(header => header.value);
    },
    items() {
      return this.formPrints.map(form => {
        const dataSourceName = this.layers[form.layer].data_source_name;
        return {
          id: form.id,
          name: form.name,
          form: this.formPrintTemplates.find(el => el.name === form.form).verbose_name,
          smart_match: this.smartMatch[form.smart_match].name,
          layer: this.layers[form.layer].name,
          relation_attribute:
            this.dataSources[dataSourceName].attributes_schema.attributes.find(
              attr => attr.name === form.relation_attribute
            )?.verbose_name || '-',
          ...form.settings,
        };
      });
    },
  },
  methods: {
    search(value = this.searchValue) {
      if (!value) this.searchedItems = [...this.items];
      else
        this.searchedItems = [...this.items].filter(item => {
          return this.searchableHeadersValues.some(header => {
            return lodashGet(item, header)
              ?.toLocaleLowerCase()
              .includes(value?.toLocaleLowerCase());
          });
        });
    },
  },
  watch: {
    searchValue: {
      handler(nV) {
        this.search(nV);
      },
      immediate: true,
    },
  },
  mounted() {
    this.search = debounce(this.search, 500);
  },
};
</script>
